import React, { Component } from "react";
import { connect } from "react-redux";
import {
  createAdminSystemFeedback,
  getAdminSystemFeedbacks,
} from "../../../actions/webinars";
import InputField from "components/InputField/InputField";

class AddFeedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user_name: "",
      body: "",
    };
  }

  onFieldChange = (e) => {
    const data = {
      ...this.state,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState(data);
  };

  render() {
    const { body, user_name } = this.state;

    return (
      <main className="site--width ">
        <h2 style={{ textAlign: "center" }}>Add new feedback</h2>
        <div className="container_form">
          <div className="section_form row">
            <InputField
              className="col s12"
              label={"User name"}
              onChange={this.onFieldChange}
              autoComplete="new-password"
              value={user_name}
              field_name="user_name"
            />
            <InputField
              className="col s12"
              label={"Body"}
              onChange={this.onFieldChange}
              autoComplete="new-password"
              value={body}
              field_name={"body"}
            />
          </div>
          <button
            style={{ display: "block", margin: "0 auto" }}
            className="button_classic"
            onClick={() => this.props.createAdminSystemFeedback(this.state)}
          >
            Add
          </button>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    getSystemFeedback: (params) => dispatch(getAdminSystemFeedbacks(params)),
    createAdminSystemFeedback: (payload) =>
      dispatch(createAdminSystemFeedback(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFeedback);



// WEBPACK FOOTER //
// ./src/containers/Admin/AddFeedback/index.jsx